import wretch from 'wretch';
import queryString from 'wretch/addons/queryString';

// API URL constants
export const ANNOUNCEMENT_API_URL = '/announcement';
export const AUTH_API_URL = '/authorization';
export const CLIENT_API_URL = '/clients';
export const NOTIFICATION_API_URL = '/notifications';
export const REFERENCE_API_URL = '/reference';
export const PAYER_REQUEST_API_URL = '/payer_request';
export const SCOPE_ASSESSOR_API_URL = '/scope-assessor';
export const TREATMENT_API_URL = '/treatment';

/** Singleton for base wretcher. Bearer token is added on login. */
export const fmhAPI = { base: wretch(process.env.REACT_APP_BASE_URL).addon(queryString) };
